import OnboardingEditor from "../components/OnboardingEditor";

function 잡동사니Page() {
  return (
    <div>
      <h1>잡동사니 Page</h1>
      <OnboardingEditor />
    </div>
  );
}

export default 잡동사니Page;
